function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M52.112 51.8756C50.7967 51.3433 49.3832 50.8678 47.8911 50.4512C46.7307 51.8712 45.5528 53.252 44.3923 54.5717C52.4916 56.3997 57.1313 59.7 57.1313 62.298C57.1313 66.1044 47.1888 71.4116 30.9989 71.4116C14.8112 71.4116 4.86873 66.1044 4.86873 62.298C4.86873 59.7 9.50843 56.3997 17.6077 54.5695C16.4451 53.2498 15.2671 51.8712 14.1089 50.4512C12.6146 50.8678 11.2033 51.3433 9.88798 51.8756C3.51194 54.4539 0 58.1556 0 62.298C0 66.4425 3.51194 70.1442 9.88798 72.7204C15.566 75.0173 23.0654 76.2803 30.9989 76.2803C38.9346 76.2803 46.4318 75.0173 52.112 72.7204C58.4881 70.1442 62 66.4425 62 62.298C62 58.1556 58.4881 54.4539 52.112 51.8756Z",
  fill: "#EA5454"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M31 0C17.1918 0 6 11.3297 6 25.3079C6 39.2862 31 62 31 62C31 62 56 39.2862 56 25.3079C56 11.3297 44.8082 0 31 0ZM31 35.3656C25.2371 35.3656 20.5647 30.6357 20.5647 24.8017C20.5647 18.9678 25.2371 14.2379 31 14.2379C36.7629 14.2379 41.4353 18.9678 41.4353 24.8017C41.4353 30.6357 36.7629 35.3656 31 35.3656Z",
  fill: "#EA5454"
});

var SvgTtIcon = function SvgTtIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 77,
    viewBox: "0 0 62 77",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTtIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tt-icon.efd366b0.svg";
export { ForwardRef as ReactComponent };